import React from 'react';
import { motion, useScroll } from 'framer-motion';

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();

  return (
    <motion.div
      style={{
        scaleX: scrollYProgress,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #a855f7, #06b6d4)', // Neon Purple to Cyan
        transformOrigin: '0%',
        zIndex: 10000,
        boxShadow: '0 0 10px #06b6d4'
      }}
    />
  );
};

export default ScrollProgress;